// extracted by mini-css-extract-plugin
export default {"feed":"YEgtrt14","header":"ysQwjGeP","title":"edUubZqe","content":"QsC6hEPv","message":"zTLkvXms"};